import {MODAL_TYPE, showModal} from '../../../../forecast-app/shared/components/modals/generic_modal_conductor';

export interface DeleteNovaAgentModalPayload {
	agentId: string;
	agentName: string;
	onDeleted: () => void;
	onTurnOffInstead: () => void;
}

export const showDeleteNovaAgentModal = (props: DeleteNovaAgentModalPayload): void => {
	showModal({type: MODAL_TYPE.NOVA_DELETE_AGENT, ...props});
};
